import React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import {
  VendorCaseStudiesData,
  VendorTestimonialsData,
  VendorVideosData,
} from "../../../store/ValtioState";

const VendorNavigation = (props) => {
  /** switch nav class based on condition primium or nonpremium
   * className={getCSSClasses(props)} changing it to classname "nav"
   *
   */

  return (
    <div className="tablist">
      <ul>
        <li className={props.match.path === "/vendor/:id" ? "active" : ""}>
          <Link to={`/vendor/${props.match.params.id}`}>
            <span className="txt">Summary</span>
          </Link>
        </li>
        {props?.vendorCommon?.testimonial_count > 0 && (
          <li
            className={
              props.match.path === "/vendor/:id/testimonials" ? "active" : ""
            }
            onClick={(e) => {
              let currentTab =
                props.match.path.split("/")[
                  props.match.path.split("/").length - 1
                ];
              let clickedTab = "testimonials";
              if (currentTab === clickedTab) {
                VendorTestimonialsData.shouldFetch = true;
              }
            }}
          >
            <Link to={`/vendor/${props.match.params.id}/testimonials`}>
              <div className={"txt_block"}>
                <span className="txt">Testimonials</span>
                <span className="badge">
                  {props.vendorCommon.testimonial_count}
                </span>
              </div>
            </Link>
          </li>
        )}
        {props?.vendorCommon?.casestudy_count > 0 && (
          <li
            className={
              props.match.path === "/vendor/:id/case-studies" ? "active" : ""
            }
            onClick={(e) => {
              let currentTab =
                props.match.path.split("/")[
                  props.match.path.split("/").length - 1
                ];

              let clickedTab = "case-studies";
              if (currentTab === clickedTab) {
                VendorCaseStudiesData.shouldFetch = true;
              }
            }}
          >
            <Link to={`/vendor/${props.match.params.id}/case-studies`}>
              <div className={"txt_block"}>
                <span className="txt">Case Studies</span>
                <span className="badge">
                  {props.vendorCommon.casestudy_count}
                </span>
              </div>
            </Link>
          </li>
        )}
        {props?.vendorCommon?.video_count > 0 && (
          <li
            className={
              props.match.path === "/vendor/:id/customer-videos"
                ? "active"
                : "txt_block"
            }
            onClick={(e) => {
              let currentTab =
                props.match.path.split("/")[
                  props.match.path.split("/").length - 1
                ];
              let clickedTab = "customer-videos";
              if (currentTab === clickedTab) {
                VendorVideosData.shouldFetch = true;
              }
            }}
          >
            <Link to={`/vendor/${props.match.params.id}/customer-videos`}>
              <div className={"txt_block"}>
                <span className="txt">
                  <span>Customer</span> Videos
                </span>
                <span className="badge">{props.vendorCommon.video_count}</span>
              </div>
            </Link>
          </li>
        )}
        {!!props.vendorCommon && !!props.vendorCommon.is_faq_tab ? (
          <li
            className={props.match.path === "/vendor/:id/faq" ? "active" : ""}
          >
            <Link to={`/vendor/${props.match.params.id}/faq`}>
              <span className="txt">
                <span>Vendor</span> FAQs
              </span>
            </Link>
          </li>
        ) : (
          ``
        )}
      </ul>
    </div>
  );
};

const componentWithRouter = withRouter(VendorNavigation);

const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
  };
};

export default connect(mapStateToProps)(componentWithRouter);
